<template>
  <div class="flex flex-row justify-evenly items-center">
    <div class="flex flex-col gap-2">
      <div class="flex flex-row">
        <p class="font-bold my-auto">Draw #</p>
        <InputNumber
          v-model="importData.drawNumber"
          showButtons
          increment-button-class="py-0! w-full"
          decrement-button-class="py-0! w-full"
          :min="0"
          class="h-10 ml-3"
          inputClass="w-16 pe-0"
          :allowEmpty="false"
          pt:buttonGroup:class="w-6!"
        ></InputNumber>
      </div>
      <StackedLabelDropdownNoForm
        v-if="importData.selectedUserGroup"
        v-model="importData.selectedUserGroup"
        name="userGroup"
        label="User Group"
        :options="userGroups"
        options-label="name"
        :disabled="userGroups.length <= 1"
        placeholder="Select a user group"
        classes="required"
      ></StackedLabelDropdownNoForm>
      <EntityLookupNoForm
        v-model:entity="importData.borrower"
        v-model:lookup-items="entities"
        name="borrower"
        label="Borrower"
        classes="required"
        defaultTBD
        :tbd-entity
      ></EntityLookupNoForm>
      <EntityLookupNoForm
        v-model:entity="importData.builder"
        v-model:lookup-items="entities"
        name="builder"
        label="Builder"
        classes="required"
        defaultTBD
        :tbd-entity
      ></EntityLookupNoForm>
      <EntityLookupNoForm
        v-model:entity="importData.inspector"
        v-model:lookup-items="entities"
        name="inspector"
        label="Inspector"
        classes="required"
        defaultTBD
        :tbd-entity
      ></EntityLookupNoForm>
    </div>
    <div class="flex flex-col text-end">
      <div class="flex flex-row justify-end font-bold text-center">
        <p class="w-[7rem]">Tab</p>
        <p class="w-16">Column</p>
        <p class="w-[7rem]">Row</p>
      </div>
      <ImportColumnPicker
        v-model:tab="fieldData.projectIdTab"
        v-model:column="fieldData.projectIdCol"
        v-model:row="fieldData.projectIdRow"
        :columns
        :disable-tab
        required
        label="Project ID"
      ></ImportColumnPicker>
      <ImportColumnPicker
        v-model:tab="fieldData.projectNameTab"
        v-model:column="fieldData.projectNameCol"
        v-model:row="fieldData.projectNameRow"
        :columns
        :disable-tab
        required
        label="Project Name"
      ></ImportColumnPicker>
      <ImportColumnPicker
        v-model:tab="fieldData.projectAddressTab"
        v-model:column="fieldData.projectAddressCol"
        v-model:row="fieldData.projectAddressRow"
        :columns
        :disable-tab
        label="Project Address"
        info="Street Address, City, State (2 Character State), Zip"
      ></ImportColumnPicker>
      <ImportColumnPicker
        v-model:tab="fieldData.projectNotesTab"
        v-model:column="fieldData.projectNotesCol"
        v-model:row="fieldData.projectNotesRow"
        :columns
        :disable-tab
        label="Project Notes"
      ></ImportColumnPicker>
      <ImportColumnPicker
        v-model:tab="fieldData.initialLenderFundsTab"
        v-model:column="fieldData.initialLenderFundsCol"
        v-model:row="fieldData.initialLenderFundsRow"
        :columns
        :disable-tab
        label="Initial Lender Funds"
      ></ImportColumnPicker>
      <ImportColumnPicker
        v-model:tab="fieldData.adjustedLenderFundsTab"
        v-model:column="fieldData.adjustedLenderFundsCol"
        v-model:row="fieldData.adjustedLenderFundsRow"
        :columns
        :disable-tab
        label="Adjusted Lender Funds"
      ></ImportColumnPicker>
      <ImportColumnPicker
        v-model:tab="fieldData.initialOtherEquityTab"
        v-model:column="fieldData.initialOtherEquityCol"
        v-model:row="fieldData.initialOtherEquityRow"
        :columns
        :disable-tab
        label="Initial Other Equity"
      ></ImportColumnPicker>
      <ImportColumnPicker
        v-model:tab="fieldData.adjustedOtherEquityTab"
        v-model:column="fieldData.adjustedOtherEquityCol"
        v-model:row="fieldData.adjustedOtherEquityRow"
        :columns
        :disable-tab
        label="Adjusted Other Equity"
      ></ImportColumnPicker>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Code } from "@/types/Codes";
import type { Entity } from "@/types/Entity";
import type { ImportProject, ImportProjectFieldData } from "@/types/Import";

const importData = defineModel<ImportProject>("importData", { required: true });
const entities = defineModel<Entity[]>("entities", { required: true });

interface Props {
  tbdEntity: Entity;
  userGroups: Code[];
  file: File | null;
}
const props = defineProps<Props>();

const columns = " ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

const disableTab = computed<boolean>(() => (props.file == null ? false : props.file.name.endsWith(".csv")));
const fieldData = defineModel<ImportProjectFieldData>("fieldData", { required: true });
</script>
